import * as THREE from 'three';

/** A dish on the ground with a mound of kibble that shrinks as it's eaten. */
export class FoodBowl {
  readonly root = new THREE.Group();
  /** 0..1 how full */
  fill = 0;
  private kibble: THREE.Mesh;

  constructor(scene: THREE.Object3D, position: THREE.Vector3) {
    const dish = new THREE.Mesh(
      new THREE.CylinderGeometry(0.2, 0.15, 0.07, 24),
      new THREE.MeshStandardMaterial({ color: 0x3f6fb5, roughness: 0.5 }),
    );
    dish.position.y = 0.035;
    dish.castShadow = true;
    dish.receiveShadow = true;
    this.root.add(dish);
    this.kibble = new THREE.Mesh(
      new THREE.SphereGeometry(0.15, 16, 10),
      new THREE.MeshStandardMaterial({ color: 0x8a5a2b, roughness: 1 }),
    );
    this.kibble.position.y = 0.05;
    this.root.add(this.kibble);
    this.root.position.copy(position);
    this.root.name = 'bowl';
    this.root.userData.tapName = 'bowl';
    scene.add(this.root);
    this.update();
  }

  /** where a dog should stand to eat: `reach` metres from the bowl, on the side of `fromPos` */
  approachPoint(fromPos: THREE.Vector3, reach: number, out: THREE.Vector3): THREE.Vector3 {
    out.subVectors(fromPos, this.root.position).setY(0);
    if (out.lengthSq() < 1e-4) out.set(0, 0, 1);
    return out.setLength(reach).add(this.root.position).setY(0);
  }

  update(): void {
    const f = Math.max(0, Math.min(1, this.fill));
    this.kibble.visible = f > 0.02;
    this.kibble.scale.set(0.6 + 0.4 * f, 0.15 + 0.45 * f, 0.6 + 0.4 * f);
  }
}
